export const SEVERITIES = ['neutral', 'info', 'success', 'warning', 'error'] as const;

export type Severity = (typeof SEVERITIES)[number];

/** Fill and foreground from one family, so the pair is one the contrast guardrail checks. */
export const severityFill: Record<Severity, string> = {
  neutral: 'bg-muted text-foreground',
  info: 'bg-info-subtle text-info-subtle-foreground',
  success: 'bg-success-subtle text-success-subtle-foreground',
  warning: 'bg-warning-subtle text-warning-subtle-foreground',
  error: 'bg-error-subtle text-error-subtle-foreground',
};

export const severityAccent: Record<Severity, string> = {
  neutral: 'border-surface-border',
  info: 'border-info',
  success: 'border-success',
  warning: 'border-warning',
  error: 'border-error',
};

export const severityClasses = (severity: Severity): string =>
  `${severityFill[severity]} ${severityAccent[severity]}`;
